import React from 'react'
import { connect } from 'react-redux'
import TextField from '../../components/TextField.js'
import redux from '../../redux/index.js'

const Note = ({
  contentType,
  properties,
  onSetProperty,
  locale
}) => {
  const key = contentType.field_internal_name
  const onChange = (value) => onSetProperty(key, value)
  const value = properties[key] || ''
  const label = locale[key] || contentType.field_title

  return (
    <TextField
      multiline
      required={contentType.ui_required}
      label={label}
      value={value}
      style={{ background: 'white' }}
      rows={3}
      rowsmax={3}
      onChange={(event) => onChange(event.target.value)}
    />
  )
}

const mapStateToProps = (state) => {
  return {
    properties: state.save.documentProperties,
    locale: state.locale.strings
  }
}

const mapDispatchToProps = (dispatch) => {
  const { save } = redux.actions
  return {
    onSetProperty: (key, value) => {
      dispatch(save.setProperty(key, value))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Note)
